import type { ReactNode } from 'react'

import ErrorBoundary from '@space-shell/common/components/errorBoundary'
import useInitializeViewAs from '@space-shell/common/hooks/useInitializeViewAs'

import BaseStructure from '../baseStructure'
import SessionEventsWrapper from '../sessionEventsWrapper'

type BaseLayoutProps = {
  children: ReactNode
}

const BaseLayout = ({ children }: BaseLayoutProps) => {
  useInitializeViewAs()

  return (
    <ErrorBoundary>
      <SessionEventsWrapper>
        <BaseStructure>{children}</BaseStructure>
      </SessionEventsWrapper>
    </ErrorBoundary>
  )
}

export default BaseLayout
